import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import ogImage from '$landing-page-raika/assets/images/og-image.png';
import twitterImage from '$landing-page-raika/assets/images/twitter-image.png';

const siteMetadataQuery = graphql`
    query {
        site {
            siteMetadata {
                title
                description
                author
                url
                twitterUsername
            }
        }
    }
`;

const PageMetadata = (props) => {
    const { title, description, lang, pathname } = props;
    const {
        site: { siteMetadata },
    } = useStaticQuery(siteMetadataQuery);

    const pageDescription = description || siteMetadata.description;

    return (
        <Helmet defer={false}>
            <html lang={lang} />
            <title>{`${title} | ${siteMetadata.title}`}</title>
            <meta name="description" content={pageDescription} />
            <link rel="canonical" href={`${siteMetadata.url}${pathname}`} />
            <meta charSet="utf-8" />
            <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no" />
            {/* Facebook */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={pageDescription} />
            <meta property="og:site_name" content={siteMetadata.title} />
            <meta property="og:locale" content={lang} />
            <meta property="og:url" content={siteMetadata.url} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:alt" content={pageDescription} />
            <meta property="og:type" content="website" />
            {/* Twitter */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={pageDescription} />
            <meta name="twitter:creator" content={siteMetadata.author} />
            <meta name="twitter:site" content={siteMetadata.twitterUsername} />
            <meta name="twitter:image" content={twitterImage} />
            <meta name="twitter:image:alt" content={pageDescription} />
            <meta name="twitter:card" content="summary" />
        </Helmet>
    );
};

PageMetadata.defaultProps = {
    description: '',
    lang: `en`,
};

PageMetadata.propTypes = {
    pathname: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    lang: PropTypes.string,
};

export default PageMetadata;
